import { render, staticRenderFns } from "./MasterPhoneNumberIndex.vue?vue&type=template&id=641389ee&scoped=true&"
import script from "./MasterPhoneNumberIndex.vue?vue&type=script&lang=js&"
export * from "./MasterPhoneNumberIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641389ee",
  null
  
)

export default component.exports